/**
 * "Forms by Documitra" document sections.
 * Mirrors backend PROCESSED_DOCUMENT_TYPE (src/common/constants.ts).
 */
export const PROCESSED_DOCUMENT_TYPES = {
  /** Draft / preview forms the applicant can accept, reject or remark; auto-deleted after PREVIEW_FORM_RETENTION_DAYS. */
  PREVIEW_FORM: 'PREVIEW_FORM',
  /** Final filled forms: read-only for the applicant, auto-deleted after FINAL_FORM_RETENTION_DAYS. */
  FINAL_FORM: 'FINAL_FORM',
  /** Government issued documents: read-only for the applicant, kept forever. */
  GOVERNMENT_DOCUMENT: 'GOVERNMENT_DOCUMENT',
} as const;

export type ProcessedDocumentType =
  typeof PROCESSED_DOCUMENT_TYPES[keyof typeof PROCESSED_DOCUMENT_TYPES];

export const FINAL_FORM_RETENTION_DAYS = 30;
export const PREVIEW_FORM_RETENTION_DAYS = 90;

/** Rows created before the documentType column existed are preview forms. */
export const isPreviewProcessedDocument = (doc: any): boolean =>
  !doc?.documentType || doc.documentType === PROCESSED_DOCUMENT_TYPES.PREVIEW_FORM;

/** All team-uploaded documents of a member (supports the legacy single processedDocument shape). */
export const getMemberProcessedDocuments = (member: any): any[] => {
  if (Array.isArray(member?.processedDocuments) && member.processedDocuments.length > 0) {
    return member.processedDocuments;
  }
  if (member?.processedDocument?.url) {
    return [member.processedDocument];
  }
  return [];
};

export const getProcessedDocumentsByType = (
  member: any,
  documentType: ProcessedDocumentType
): any[] =>
  getMemberProcessedDocuments(member).filter((doc: any) =>
    documentType === PROCESSED_DOCUMENT_TYPES.PREVIEW_FORM
      ? isPreviewProcessedDocument(doc)
      : doc?.documentType === documentType
  );
